import { render } from "./AdminNavigationContainer.vue?vue&type=template&id=78aa73a4&ts=true"
import script from "./AdminNavigationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminNavigationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./AdminNavigationContainer.vue?vue&type=style&index=0&id=78aa73a4&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AdminNavigationContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78aa73a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78aa73a4', __exports__)) {
    console.log('reload')
    api.reload('78aa73a4', __exports__)
  }
  
  module.hot.accept("./AdminNavigationContainer.vue?vue&type=template&id=78aa73a4&ts=true", () => {
    console.log('re-render')
    api.rerender('78aa73a4', render)
  })

}


export default __exports__